// hooks
import { useApolloClient } from 'hooks/useApolloClient'
// graphql
import { CREATE_BOOKMARK, DELETE_BOOKMARK } from 'graphql/bookmarks/mutations'
// utils
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

export const useBookmarks = () => {
  const { client } = useApolloClient()

  const createOrDeleteBookmark = async (input, isBookmark) => {
    try {
      await client.mutate({
        mutation: isBookmark ? DELETE_BOOKMARK : CREATE_BOOKMARK,
        variables: {
          input
        }
      })
    } catch (e) {
      console.log('[useBookmarks.createOrDeleteBookmark]: ', parseGraphQLErrorMessages(e))
    }
  }

  return createOrDeleteBookmark
}
